const onContractsPageMatch = () => {
  const waitForPageLoad = setInterval(() => {
    const pageContent = document.querySelector('.TenantContractEditor')
    if (pageContent && (isInRole('zhv') || isInRole('tech'))) {
      clearInterval(waitForPageLoad)
      const headerButtons = document.querySelector('.header-buttons')
      if (headerButtons && headerButtons.firstElementChild) {
        const existingButton = headerButtons.querySelector('#kautionsassistent-button');
        if (existingButton) {
          return;
        }

        const clonedButton = headerButtons.firstElementChild.cloneNode(true)
        clonedButton.id = 'kautionsassistent-button';
        clonedButton.textContent = 'Kautionsassistent'
        clonedButton.style.backgroundColor = 'black'
        clonedButton.style.color = 'white'
        headerButtons.insertBefore(clonedButton, headerButtons.children[1])

        clonedButton.addEventListener('click', () => {
          const authString = localStorage.getItem('auth');
          if (!authString) {
            console.error('Kautionsassistent Error: Auth not found in localStorage.');
            alert("Fehler: Kautionsassistent erfordert eine aktive Anmeldung.");
            return;
          }

          const authData = JSON.parse(authString);
          const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
          const email = decodedToken.sub
          const domainId = decodedToken.domainId

          try {
            if (!authData || !authData.token || !domainId || !email) {
              throw new Error("Invalid auth data structure.");
            }
          } catch (error) {
            console.error('Kautionsassistent Error: Failed to parse auth data from localStorage:', error);
            alert("Fehler: Ungültige Anmeldedaten gefunden.");
            return;
          }

          let propertyHrId = null;
          let unitContractId = null;
          const urlPath = window.location.pathname;
          const urlMatch = urlPath.match(/properties\/([^/]+)\/.*?\/edit\/([^/?]+)/);

          if (urlMatch && urlMatch.length >= 3) {
              propertyHrId = urlMatch[1];
              unitContractId = urlMatch[2];
              console.log(`Kautionsassistent: Extracted propertyHrId=${propertyHrId}, unitContractId=${unitContractId}`);
          } else {
              console.error('Kautionsassistent Error: Could not extract propertyHrId and unitContractId from URL:', urlPath);
              alert("Fehler: Kontext für Kautionsassistent konnte nicht ermittelt werden (IDs nicht gefunden).");
              return;
          }

          
          var iframe = document.createElement('iframe')
          const iframeSrc = `${baseApiUrl}/injects/kaution?propertyHrId=${encodeURIComponent(propertyHrId)}&unitContractId=${encodeURIComponent(unitContractId)}&domainId=${encodeURIComponent(domainId)}&userEmail=${encodeURIComponent(userEmail)}&pw=OsAK1823`;
          console.log("Setting Kaution Iframe src:", iframeSrc);
          iframe.style.width = '100%'
          iframe.style.height = '100%'
          iframe.style.border = 'none'
          iframe.style.display = 'none'
          iframe.style.backgroundColor = 'transparent'

          var overlay = document.createElement('div')
          overlay.style.position = 'fixed'
          overlay.style.top = '0'
          overlay.style.left = '0'
          overlay.style.width = '100%'
          overlay.style.height = '100%'
          overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.8)'
          overlay.style.zIndex = '10000'
          overlay.style.display = 'flex'
          overlay.style.justifyContent = 'center'
          overlay.style.alignItems = 'center'
          
          var loadingContainer = document.createElement('div')
          loadingContainer.style.backgroundColor = 'white'
          loadingContainer.style.padding = '20px'
          loadingContainer.style.borderRadius = '8px'
          loadingContainer.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)'
          loadingContainer.style.display = 'flex'
          loadingContainer.style.flexDirection = 'column'
          loadingContainer.style.alignItems = 'center'
          loadingContainer.style.justifyContent = 'center'
          
          var spinner = document.createElement('div')
          spinner.style.width = '40px'
          spinner.style.height = '40px'
          spinner.style.border = '4px solid rgba(0, 0, 0, 0.1)'
          spinner.style.borderRadius = '50%'
          spinner.style.borderTop = '4px solid #3498db'
          spinner.style.animation = 'spin 1s linear infinite'
          
          var style = document.createElement('style')
          style.innerHTML = `
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `
          document.head.appendChild(style)
          
          var loadingText = document.createElement('div')
          loadingText.textContent = 'Laden...'
          loadingText.style.marginTop = '10px'
          loadingText.style.fontFamily = 'Arial, sans-serif'
          loadingText.style.fontSize = '16px'
          
          loadingContainer.appendChild(spinner)
          loadingContainer.appendChild(loadingText)
          
          overlay.appendChild(loadingContainer)
          
          document.body.appendChild(overlay)

          overlay.appendChild(iframe)          
          iframe.src = iframeSrc;


          iframe.onload = function() {
              loadingContainer.style.display = 'none'
              iframe.style.display = 'block'
              overlay.style.backgroundColor = 'transparent'
          }

          window.addEventListener('message', (event) => {
            if (event.data.type === 'CLOSE_DEPOSIT_MODAL') {
              document.body.removeChild(overlay)
              document.head.removeChild(style)
            } else if (event.data.type === 'redirectToPath') {
              window.location.href = event.data.path
            }
          });
        })
      }
    }
  }, 100)
}